import { render, staticRenderFns } from "./IncorrectSubdomainComponent.vue?vue&type=template&id=15555fbd&"
import script from "./IncorrectSubdomainComponent.vue?vue&type=script&lang=js&"
export * from "./IncorrectSubdomainComponent.vue?vue&type=script&lang=js&"
import style0 from "./IncorrectSubdomainComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports